














import { UserSalutation } from '@front-app/services/UserApi/UserModel';
import { computed, defineComponent } from '@vue/composition-api';
import SelectBox from './SelectBox.vue';

const ORDERED_KEYS = [
	UserSalutation.NONE,
	UserSalutation.DR,
	UserSalutation.MISS,
	UserSalutation.MR,
	UserSalutation.MRS,
	UserSalutation.MS,
	UserSalutation.PROF,
];

const DEFAULT_VALUE = UserSalutation.NONE;

export default defineComponent({
	components: { SelectBox },
	props: {
		value: {
			type: String,
			default: DEFAULT_VALUE,
		},
	},
	setup(props, ctx) {
		const getLabelForKey = (key: UserSalutation) => ctx.root.$t(key);
		const selectOptions = computed(() => ORDERED_KEYS
			.map((key) => ({
				key,
				label: getLabelForKey(key),
			})));
		return {
			selectOptions,
			getLabelForKey,
			noneOption: UserSalutation.NONE,
		};
	},
});
